import { render, staticRenderFns } from "./ProfileNonIdentStandardVolunteerForm.vue?vue&type=template&id=4e60ee83&scoped=true"
import script from "./ProfileNonIdentStandardVolunteerForm.vue?vue&type=script&lang=ts"
export * from "./ProfileNonIdentStandardVolunteerForm.vue?vue&type=script&lang=ts"
import style0 from "./ProfileNonIdentStandardVolunteerForm.vue?vue&type=style&index=0&id=4e60ee83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e60ee83",
  null
  
)

export default component.exports